module.exports = ".main-container {\n  margin-top: 60px;\n  margin-left: 235px;\n  padding: 15px;\n  -ms-overflow-x: hidden;\n  overflow-x: hidden;\n  overflow-y: scroll;\n  position: relative;\n  overflow: hidden; }\n\n@media screen and (max-width: 992px) {\n  .main-container {\n    margin-left: 0px !important; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layouts/full/full.component.scss
// module id = ./src/app/layouts/full/full.component.scss
// module chunks = main